import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EntityViewerDemoComponent } from './entity-viewer-demo/entity-viewer-demo.component';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule
  ],
  declarations: [EntityViewerDemoComponent],
  exports: [ EntityViewerDemoComponent]
})
export class EntityViewerModule { }
